import React, { Component } from 'react';
import './mailchimp.css'

class MailChimp extends Component {
    render() {
        return (
            <div id="mailchimp_form">
            <link href="//cdn-images.mailchimp.com/embedcode/horizontal-slim-10_7.css" rel="stylesheet" type="text/css" />
            <style type="text/css"/>
            <div id="mc_embed_signup">
              <form action="//jessmchung.us16.list-manage.com/subscribe/post?u=02b86c805bcd20ea2b193465f&id=006a13eefd" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_blank" noValidate>
                <div id="mc_embed_signup_scroll">
                    <input type="email" name="EMAIL" className="email" id="mce-EMAIL" placeholder="email address" required />
                    <div style={{position: 'absolute', left: '-5000px'}} aria-hidden="true"><input type="text" name="b_02b86c805bcd20ea2b193465f_006a13eefd" tabIndex={-1} defaultValue /></div>
                    <div className="clear">
                        <input type="submit" defaultValue="Subscribe" name="subscribe" id="mc-embedded-subscribe" className="button" />
                    </div>
                </div>
              </form>
            </div>
            </div>
        );
    }
}

export default MailChimp;



// WEBPACK FOOTER //
// ./src/components/mailchimp/mailchimp.js